export const errorMessage: Utils.Object<string, string> = {
  '0': "Une erreur s'est produite.",
  '400': 'La syntaxe de la requête est erronée.',
  '401': 'Une authentification est nécessaire pour accéder à la ressource.',
  '404': 'Ressource non trouvée.',
  '500': 'Erreur interne du serveur.',
  '501': 'Fonctionnalité réclamée non supportée par le serveur.',
  // Subscription error codes
  '1040': 'Code opération erroné',
  '1041': 'Code promo expiré',
  '1042': 'Code opération non autorisé',
}
